import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import {
  ErrorBoundary,
  buildTheme,
  injectThemeCssVariables,
  toAntdTokens,
} from '@mall/shared';
import { AppRouter } from './app/AppRouter';
import { ToastProvider } from './app/ToastProvider';
import { AuthProvider } from './features/auth/AuthProvider';
import './styles/global.css';

const theme = buildTheme('admin');
injectThemeCssVariables(theme);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{ token: toAntdTokens(theme) }}>
      <AntApp>
        <ToastProvider>
          <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
                <AuthProvider>
                  <AppRouter />
                </AuthProvider>
              </BrowserRouter>
            </QueryClientProvider>
          </ErrorBoundary>
        </ToastProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
